import React, { Component } from "react";
import {
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Button,
  TextField,
  InputAdornment,
  IconButton,
  Icon,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogContent,
  DialogActions,
  LinearProgress,
  Snackbar,
  Slide
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { objectAsParams } from "../../../helpers";
import "./Documentacion.css";
import CobroServicios from "../../Catalogos/clientes/precios/cobroServicios";
import Http from "../../../Http";
import ManifiestosCliente from "../../Catalogos/clientes/manifiestos/ManifiestosCliente";
import GuiaProductos from "../GuiaProductos";

export default class DocumenacionDetalles extends Component {
  constructor(props) {
    super(props);
    const defaultServices = props.cliente_cpac
      ? [
          {
            id_lista_precio_tipo: 2,
            id_valor_aplicado: 1,
          },
          {
            id_lista_precio_tipo: 3,
            id_valor_aplicado: 1,
            valor_aplicado: 0,
            concepto: 1,
            fecha_cita_ead: null,
          },
          {
            id_lista_precio_tipo: 10,
            id_valor_aplicado: 1,
            valor_aplicado: 0,
            concepto: 1,
            fecha_cita_ead: null,
          },
        ]
      : [
          {
            id_lista_precio_tipo: 2,
            id_valor_aplicado: 1,
          },
          {
            id_lista_precio_tipo: 3,
            id_valor_aplicado: 1,
            valor_aplicado: 0,
            concepto: 1,
            fecha_cita_ead: null,
          },
        ];

    this.state = {
      guia: {
        g_id_tipo_precio: "1",
        g_tipo_precio_valor: "",
        id_grupo_embalaje: "1",
        g_observaciones: "Sin observaciones",
        g_dimensiones: "Sin especificar",
        g_volumen_largo: "0",
        g_volumen_alto: "0",
        g_volumen_ancho: "0",
        g_peso_volumetrico: "0",
        g_peso_real: "",
        g_piezas: "",
        paquetes: [],
        productos: [],
        g_costo_subtotal: "",
        g_costo_iva: "",
        g_costo_retencion: "",
        g_costo_total: "",
      },
      valid: false,
      activateByManifiesto: false,
      embalaje_grupos: [],
      embalajes: [],
      requiredFields: [
        { key: "g_id_tipo_precio", name: "Tipo de Precio" },
        { key: "id_grupo_embalaje", name: "Grupo de Embalaja" },
        // { key: 'g_observaciones', name: 'Observaciones' },
        { key: "g_peso_real", name: "Peso" },
        { key: "g_piezas", name: "Unidades" },
        // { key: 'g_dimensiones', name: 'Dimensiones' },
      ],
      tiposCobro: [],
      serviciosIncluidos: props.serviciosIncluidos || defaultServices,
      cobrosAplicados: {},
      priceInfo: {},
      cliente: {},
      dialogManifiesto: { visible: false },
      manifiesto: {},
      calculating: false,
      searchProducto: {},
      searchProductoOptions: {},
      searchUnidad: {},
      searchUnidadOptions: {},
      sbOpen: false,
      sbMsg: '',
    };
  }

  async componentDidMount() {
    this.setState({ disabled: this.props.disabled });
    await this.getFormData({ initial: true });
    if (this.props.guia) {
      const { serviciosIncluidos } = this.state;
      if (this.props.guia.g_id_preguia && this.props.guia.g_id_preguia !== "") {
        serviciosIncluidos.push({
          id_lista_precio_tipo: 1,
          id_valor_aplicado: 1,
          valor_aplicado: 0,
        });
      }
      this.setState({ guia: this.props.guia }, () => {
        if (
          this.props.guia.paquetes &&
          this.props.guia.paquetes.length > 0 &&
          !this.props.guia.g_costo_total &&
          Number(this.props.guia.g_id_tipo_precio) !== 3 &&
          Number(this.props.guia.g_id_tipo_precio) !== 4
        ) {
          this.onCalculate();
        }
      });
    }
  }

  getFormData = async ({ eg, initial, index, prop }) => {
    const { guia } = this.props;
    let {
      embalaje_grupos,
      embalajes,
      tiposCobro,
      cliente,
      searchProducto,
      searchProductoOptions,
      searchUnidad,
      searchUnidadOptions,
    } = this.state;
    const params = {};
    if (eg) {
      params["eg"] = eg;
    } else if (
      guia &&
      guia.id_grupo_embalaje &&
      guia.id_grupo_embalaje !== ""
    ) {
      params["eg"] = guia.id_grupo_embalaje;
    }

    params["gc"] = guia.g_id_cliente;

    if (initial) {
      params["initial"] = true;
      if (guia && guia.paquetes && guia.paquetes.length > 0) {
        params["id_productos"] = guia.paquetes
          .filter((paq) => paq.gp_id_producto && paq.gp_id_producto > 0)
          .map((paq) => paq.gp_id_producto)
          .toString();
        params["id_unidades"] = guia.paquetes
          .filter((paq) => paq.gp_id_unidad && paq.gp_id_unidad > 0)
          .map((paq) => paq.gp_id_unidad)
          .toString();
      }
    }
    if (prop === "gp_id_producto") {
      params["productoq"] = searchProducto[index];
    }
    if (prop === "gp_id_unidad") {
      params["unidadq"] = searchUnidad[index];
    }

    let Res = await Http.get(`guia/detalle-form?${objectAsParams(params)}`);
    if (!Res.error) {
      if (Res.data.embalaje_grupos) {
        embalaje_grupos = Res.data.embalaje_grupos;
      }
      if (Res.data.embalajes) {
        embalajes = Res.data.embalajes;
      }
      if (Res.data.tiposDeCobro) {
        tiposCobro = Res.data.tiposDeCobro;
      }
      if (Res.data.cliente) {
        cliente = Res.data.cliente || {};
      }
      if (!initial) {
        if (Res.data.unidades) {
          searchUnidadOptions[index] = Res.data.unidades;
        }
        if (Res.data.productos) {
          searchProductoOptions[index] = Res.data.productos;
        }
      } else {
        if (Res.data.unidades && Res.data.productos && Res.data.unidades.length > 0 && Res.data.productos.length > 0) {
          for (let index = 0; index < guia.paquetes.length; index++) {
            searchUnidadOptions[index] = Res.data.unidades;
            searchProductoOptions[index] = Res.data.productos;
            const labelProducto = Res.data.productos.filter(
              (prod) => prod.id === guia.paquetes[index].gp_id_producto
            )[0];
            const labelUnidad = Res.data.unidades.filter(
              (prod) => prod.id === guia.paquetes[index].gp_id_unidad
            )[0];
            searchProducto[index] = labelProducto ? labelProducto.label : '';
            searchUnidad[index] = labelUnidad ? labelUnidad.label : '';
          }
        }
      }
    }

    this.setState({
      embalaje_grupos,
      embalajes,
      tiposCobro,
      cliente,
      searchProductoOptions,
      searchUnidadOptions,
    });
  };

  agregarPaquete = () => {
    const {
      guia,
      searchProducto,
      searchProductoOptions,
      searchUnidadOptions,
      searchUnidad,
    } = this.state;
    guia.paquetes.push({
      gp_cantidad: "",
      gp_id_embalaje: "",
      gp_descripcion: "",
      gp_peso: "",
      gp_precio: "",
      gp_tipo_cobro: "",
      gp_id_unidad: "",
      gp_id_producto: "",
      gp_valor: "",
    });
    searchProducto[guia.paquetes.length - 1] = "";
    searchProductoOptions[guia.paquetes.length - 1] = [];
    searchUnidad[guia.paquetes.length - 1] = "";
    searchUnidadOptions[guia.paquetes.length - 1] = [];
    this.setState({
      guia,
      searchProducto,
      searchProductoOptions,
      searchUnidad,
      searchUnidadOptions,
    });
  };

  paqueteAutocompleChange = (i, prop, value) => {
    let { searchProducto, searchUnidad } = this.state;
    if (value !== 0 && value.length > 0) {
      if (prop === "gp_id_producto") {
        searchProducto[i] = value;
        this.setState({ searchProducto });
      } else if (prop === "gp_id_unidad") {
        searchUnidad[i] = value;
        this.setState({ searchUnidad });
      }

      if (value.length > 1) {
        this.getFormData({ index: i, prop });
      }
    }
  };

  paqueteChange = (i, prop, value) => {
    let { guia } = this.state;
    guia.paquetes[i][prop] = value;
    guia.g_peso_real = guia.paquetes
      .map((paq) => paq.gp_peso)
      .reduce((paq, current) => Number(paq) + Number(current));
    guia.g_piezas = guia.paquetes
      .map((paq) => paq.gp_cantidad)
      .reduce((paq, current) => Number(paq) + Number(current));
    this.setState({ guia, valid: this.validateFields(guia) }, () => {
      /*       const validFields = guia.paquetes.every((paquete) => (paquete.gp_cantidad !== '' && paquete.gp_id_embalaje !== '' && paquete.gp_peso !== ''));
      if (validFields && ['gp_cantidad', 'gp_id_embalaje', 'gp_peso'].includes(prop)) {
        this.onCalculate();
      } */
    });
  };

  paqueteOnBlur = (i, prop, value) => {
    let { guia } = this.state;
    const validFields = guia.paquetes.every(
      (paquete) =>
        paquete.gp_cantidad !== "" &&
        paquete.gp_id_embalaje !== "" &&
        paquete.gp_peso !== ""
    );
    if (validFields) {
      this.onCalculate();
    }
  };

  paqueteDelete = (indexPaquete) => {
    const { guia } = this.state;
    guia.paquetes = guia.paquetes.filter((p, i) => i !== indexPaquete);

    this.setState({ guia });
  };

  onSubmit = async () => {
    let {
      guia,
      cobrosAplicados,
      serviciosIncluidos,
      manifiestos = [],
    } = this.state;
    this.setState({ valid: false });
    let manifiestosId = manifiestos.map((m) => m.id);
    let error = false;
    for (const paq of guia.paquetes) {
      if (!paq.gp_id_unidad || paq.gp_id_unidad === 0 || paq.gp_id_unidad === '') {
        error = 'verificar que todos los paquetes contengan unidad'
      }
      if (!paq.gp_id_producto || paq.gp_id_producto === 0 || paq.gp_id_producto === '') {
        error = 'verificar que todos los paquetes contengan producto'
      }
    }
    for (const prod of guia.productos) {
      if (!prod.clave_unidad || prod.clave_unidad === 0 || prod.clave_unidad === '') {
        error = 'verificar que todos los PRODUCTOS contengan unidad'
      }
      if (!prod.producto_clave || prod.producto_clave === 0 || prod.producto_clave === '') {
        error = 'verificar que todos los PRODUCTOS contengan producto'
      }
    }
    if (error) {
      this.setState({ sbMsg: error, sbOpen: true })
    } else {
      await this.props.onSave({
        guia,
        paquetes: guia.paquetes,
        productos: guia.productos,
        cobrosAplicados,
        serviciosIncluidos,
        manifiestosId: manifiestosId,
      });
      this.setState({ valid: true });
    }
  };

  onValueChange = (event, property) => {
    let { guia, requiredFields } = this.state;
    guia[property] = event.target.value;
    if (property === "g_id_tipo_precio" && event.target.value === "2") {
      requiredFields.push({
        key: "g_tipo_precio_valor",
        name: "Valor tipo precio",
      });
    }
    this.setState(
      { guia, requiredFields, valid: this.validateFields(guia) },
      () => {
        if (property === "g_id_tipo_precio") {
          this.onCalculate();
        }
      }
    );
  };

  onCalculate = async () => {
    this.setState({ calculating: true, disabled: true });
    let { guia, serviciosIncluidos, tiposCobro, priceInfo } = this.state;
    let Res = await Http.post("guia/precio", {
      guia,
      paquetes: guia.paquetes,
      serviciosIncluidos,
    });
    if (!Res.error) {
      for (const [index, paquete] of Res.data.Paquetes.entries()) {
        guia.paquetes[index]["gp_precio"] = Number(paquete.gp_precio).toFixed(
          3
        );
        guia.paquetes[index]["gp_tipo_cobro"] = paquete.gp_tipo_cobro;
        guia.paquetes[index]["gp_id_especificacion_aplicada"] =
          paquete.gp_id_especificacion_aplicada;
      }
      for (const tipoCobro of tiposCobro) {
        guia[`tipo_${tipoCobro.id}`] = Res.data[`tipo_${tipoCobro.id}`]
          ? Res.data[`tipo_${tipoCobro.id}`].valor_aplicado
          : 0;
        priceInfo[`tipo_${tipoCobro.id}`] = {
          lp: Res.data[`tipo_${tipoCobro.id}`]
            ? Res.data[`tipo_${tipoCobro.id}`].tipo_cobro
            : null,
          km: Res.data[`tipo_${tipoCobro.id}`]
            ? Res.data[`tipo_${tipoCobro.id}`].KM
            : null,
        };
      }
      guia.g_costo_subtotal = Number(
        Res.data.g_costo_subtotal.valor_aplicado
      ).toFixed(2);
      guia.g_costo_iva = Number(Res.data.g_costo_iva.valor_aplicado).toFixed(2);
      guia.g_costo_retencion = Number(
        Res.data.g_costo_retencion.valor_aplicado
      ).toFixed(2);
      guia.g_costo_total = Number(
        Res.data.g_costo_total.valor_aplicado
      ).toFixed(2);
      guia.factor_cpac = Res.data.factor_cpac;
      this.setState({
        guia,
        cobrosAplicados: { ...Res.data, Paquetes: undefined },
        calculating: false,
        disabled: false,
      });
    }
  };

  validateFields = (guia) => {
    const { requiredFields } = this.state;
    return requiredFields.every(
      (reqField) =>
        guia[reqField.key] + "" &&
        (guia[reqField.key] + "").length > 0 &&
        guia[reqField.key] !== ""
    );
  };

  handleOnUserSelectService = (listaPrecios, trigger) => {
    let { serviciosIncluidos, guia } = this.state;
    console.log("especificaciones", listaPrecios.especificaciones);
    console.log("serviciosIncluidos", serviciosIncluidos);
    // serviciosIncluidos = listaPrecios.especificaciones;
    this.setState({ serviciosIncluidos: listaPrecios.especificaciones }, () => {
      const validFields =
        guia.paquetes.length > 0 &&
        guia.paquetes.every(
          (paquete) =>
            paquete.gp_cantidad !== "" &&
            paquete.gp_id_embalaje !== "" &&
            paquete.gp_peso !== ""
        );
      if (validFields && trigger) {
        this.onCalculate();
      } else {
        this.setState({ valid: false });
      }
    });
  };

  onSelectManifiesto = (rows) => {
    let { guia, disabled, valid } = this.state;
    guia["g_observaciones"] = rows.map((row) => row.orden).join(", ");
    let activateByManifiesto = false;
    if (disabled) {
      activateByManifiesto = true;
      valid = true;
    }
    this.setState({
      manifiestos: rows,
      dialogManifiesto: { visible: false },
      activateByManifiesto,
      valid,
    });
  };

  render() {
    const {
      embalaje_grupos,
      embalajes,
      valid,
      guia,
      serviciosIncluidos,
      priceInfo,
      searchProducto,
      searchProductoOptions,
      searchUnidad,
      searchUnidadOptions,
      guia: {
        g_id_tipo_precio,
        g_tipo_precio_valor,
        id_grupo_embalaje,
        g_observaciones,
        g_dimensiones,
        g_volumen_largo,
        g_volumen_alto,
        g_volumen_ancho,
        g_peso_volumetrico,
        g_peso_real,
        g_piezas,
        g_autoservicio,
        g_almacenaje,
        g_completo,
        paquetes,
        productos = [],
      },
      tiposCobro,
      cliente,
      dialogManifiesto,
      manifiestos = [],
      calculating = true,
      disabled,
      activateByManifiesto,
      showDetailProduct = false,
      sbOpen = false,
      sbMsg = '',
    } = this.state;
    const { noDetalles } = this.props;

    return (
      <div style={{ padding: 15 }}>
        <div className="row">
          <div className="col-12 col-sm-6">
            <FormControl variant="outlined" className="form-field">
              <InputLabel>Tipo de Precio</InputLabel>
              <Select
                disabled={disabled ? disabled : false}
                value={g_id_tipo_precio}
                onChange={(value) => {
                  this.onValueChange(value, "g_id_tipo_precio");
                }}
              >
                <MenuItem value={"1"}>Consolidado</MenuItem>
                <MenuItem value={"2"}>Porcentaje</MenuItem>
                <MenuItem value={"3"}>Devolución</MenuItem>
                <MenuItem value={"4"}>Guia Interna</MenuItem>
                {/* <MenuItem value={'4'} >
                  Servicio Local
                </MenuItem> 
                <MenuItem value={"5"}>Kilos</MenuItem>
                */}
              </Select>
            </FormControl>
          </div>
          {(g_id_tipo_precio === "2" || g_id_tipo_precio === 2) && (
            <div className="col-sm-6">
              <FormControl variant="outlined" className="form-field">
                <TextField
                  disabled={disabled ? disabled : false}
                  value={g_tipo_precio_valor}
                  onChange={(event) =>
                    this.onValueChange(event, "g_tipo_precio_valor")
                  }
                  type="number"
                  label="Valor Factura"
                  variant="outlined"
                />
              </FormControl>
            </div>
          )}
          <div className="col-12 col-sm-6">
            <FormControl variant="outlined" className="form-field">
              <InputLabel>Grupo de Embalaje</InputLabel>
              <Select
                disabled={true}
                // readOnly
                value={embalaje_grupos.length > 0 ? id_grupo_embalaje : ""}
                onChange={(value) => {
                  this.onValueChange(value, "id_grupo_embalaje");
                  this.getFormData({ eg: value.target.value });
                }}
              >
                {embalaje_grupos.map((carga, i) => (
                  <MenuItem value={carga.id} key={`grupo-${i}`}>
                    {carga.grupo}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>

        <div style={{ textAlign: "right", paddingTop: 10, paddingBottom: 10 }}>
          {calculating && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div>Calculando Precio</div>
              <div style={{ width: "100%" }}>
                <LinearProgress />
              </div>
            </div>
          )}
          <Button
            variant="contained"
            color="primary"
            onClick={this.agregarPaquete}
            disabled={disabled ? disabled : false}
          >
            Agregar paquete
          </Button>
        </div>

        <div className="guia-detalles">
          {paquetes.map((paquete, index) => (
            <div className="row paquete-row" key={`paquete-row-${index}`}>
              <div className="col-sm-2">
                <FormControl variant="outlined" className="form-field">
                  <TextField
                    disabled={disabled ? disabled : false}
                    value={paquete["gp_cantidad"] || ''}
                    onBlur={(e) => {
                      this.paqueteOnBlur(index, "gp_cantidad", e.target.value);
                    }}
                    // error={showError && paquete['gp_cantidad']['error']}
                    onChange={(e) => {
                      this.paqueteChange(index, "gp_cantidad", e.target.value);
                    }}
                    type="number"
                    label="Cantidad"
                    variant="outlined"
                    inputProps={{
                      min: 0,
                    }}
                  />
                </FormControl>
              </div>
              <div className="col-sm-2">
                <Autocomplete
                  disabled={disabled ? disabled : false}
                  className="form-field"
                  inputValue={searchUnidad[index] ? searchUnidad[index] : ""}
                  getOptionLabel={(option) =>
                    option ? option.label || "" : ""
                  }
                  options={
                    searchUnidadOptions[index] ? searchUnidadOptions[index] : []
                  }
                  onInputChange={(e, newInputValue) => {
                    /* console.log('e', e.target.value) */
                    console.log("newInputValue", newInputValue);
                    this.paqueteAutocompleChange(
                      index,
                      "gp_id_unidad",
                      newInputValue
                    );
                  }}
                  value={paquete["gp_id_unidad"] ? paquete["gp_id_unidad"] : ""}
                  onChange={(event, newValue) => {
                    this.paqueteChange(
                      index,
                      "gp_id_unidad",
                      newValue ? newValue.id : ""
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={`Unidad`}
                      variant="outlined"
                      fullWidth
                      // onBlur={(e) => { this.fieldBlur(formField, e) }}
                    />
                  )}
                />
              </div>
              <div className="col-sm-2">
                <Autocomplete
                  disabled={disabled ? disabled : false}
                  className="form-field"
                  value={
                    paquete["gp_id_producto"] ? paquete["gp_id_producto"] : ""
                  }
                  onChange={(event, newValue) => {
                    this.paqueteChange(
                      index,
                      "gp_id_producto",
                      newValue ? newValue.id : ""
                    );
                  }}
                  inputValue={
                    searchProducto[index] ? searchProducto[index] : ""
                  }
                  getOptionLabel={(option) =>
                    option ? option.label || "" : ""
                  }
                  options={searchProductoOptions ? (searchProductoOptions[index] ? searchProductoOptions[index]: []) : []}
                  onInputChange={(e, newInputValue) => {
                    /* console.log('e', e.target.value) */
                    console.log("newInputValue", newInputValue);
                    this.paqueteAutocompleChange(
                      index,
                      "gp_id_producto",
                      newInputValue
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={`Producto`}
                      variant="outlined"
                      fullWidth
                      // onBlur={(e) => { this.fieldBlur(formField, e) }}
                    />
                  )}
                />
              </div>
{/*               <div className="col-sm-2">
                <FormControl variant="outlined" className="form-field">
                  <TextField
                    disabled={disabled ? disabled : false}
                    value={paquete["gp_valor"] || ""}
                    onBlur={(e) => {
                      this.paqueteOnBlur(index, "gp_valor", e.target.value);
                    }}
                    onChange={(e) => {
                      this.paqueteChange(index, "gp_valor", e.target.value);
                    }}
                    type="number"
                    label="Valor de Mercancia ($)"
                    variant="outlined"
                    inputProps={{
                      min: 0,
                    }}
                  />
                </FormControl>
              </div> */}
              <div className="col-sm-2">
                <FormControl variant="outlined" className="form-field">
                  <InputLabel>Embalaje</InputLabel>
                  <Select
                    disabled={disabled ? disabled : false}
                    value={paquete["gp_id_embalaje"] || ''}
                    onBlur={(e) => {
                      this.paqueteOnBlur(
                        index,
                        "gp_id_embalaje",
                        e.target.value
                      );
                    }}
                    onChange={(e) => {
                      this.paqueteChange(
                        index,
                        "gp_id_embalaje",
                        e.target.value
                      );
                    }}
                  >
                    {embalajes.map((embalaje, i) => (
                      <MenuItem value={embalaje.id} key={i}>
                        {embalaje.embalaje}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div className="col-sm-2">
                <FormControl variant="outlined" className="form-field">
                  <TextField
                    value={paquete["gp_descripcion"] || ''}
                    disabled={disabled ? disabled : false}
                    // error={showError && paquete['gp_descripcion']['error']}
                    onChange={(e) => {
                      this.paqueteChange(
                        index,
                        "gp_descripcion",
                        e.target.value
                      );
                    }}
                    type="number"
                    label="Descripción"
                    multiline
                    fullWidth
                    minRows="1"
                    variant="outlined"
                  />
                </FormControl>
              </div>
              <div className="col-sm-2">
                <FormControl variant="outlined" className="form-field">
                  <TextField
                    disabled={disabled ? disabled : false}
                    value={paquete["gp_peso"] || ''}
                    onBlur={(e) => {
                      this.paqueteOnBlur(index, "gp_peso", e.target.value);
                    }}
                    // error={showError && paquete['gp_peso']['error']}
                    onChange={(e) => {
                      this.paqueteChange(index, "gp_peso", e.target.value);
                    }}
                    type="number"
                    label="Peso(kg)"
                    variant="outlined"
                    inputProps={{
                      min: 0,
                    }}
                  />
                </FormControl>
              </div>
              <div className="col-sm-2">
                <FormControl variant="outlined" className="form-field">
                  <TextField
                    disabled={disabled ? disabled : false}
                    value={paquete["gp_precio"] || ''}
                    readOnly
                    // error={showError && paquete['gp_precio']['error']}
                    // onChange={(e) => { this.paqueteChange(index, 'gp_precio', e.target.value) }}
                    type="number"
                    label="Precio"
                    variant="outlined"
                  />
                </FormControl>
              </div>
              <div className="col-sm-2">
                <FormControl variant="outlined" className="form-field">
                  <TextField
                    disabled={disabled ? disabled : false}
                    // error={showError && paquete['gp_tipo_cobro']['error']}
                    value={paquete["gp_tipo_cobro"] || ''}
                    readOnly
                    // onChange={(e) => { this.paqueteChange(index, 'gp_tipo_cobro', e.target.value) }}
                    label="Tipo de cobro"
                    variant="outlined"
                  />
                </FormControl>
              </div>
              <div className="col-sm-1">
                <IconButton
                  disabled={disabled ? disabled : false}
                  onClick={() => {
                    this.paqueteDelete(index);
                  }}
                >
                  <Icon>remove_circle</Icon>
                </IconButton>
              </div>
            </div>
          ))}
          {paquetes.length < 1 && (
            <span style={{ textAlign: "center" }}>NO HAY PAQUETES</span>
          )}
        </div>
        <div
          style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}
        >
          <Button
            color="primary"
            onClick={() => {
              this.setState({ showDetailProduct: !showDetailProduct });
            }}
          >
            Detallar Productos
          </Button>
        </div>
        {showDetailProduct && (
          <div className="preguia-detalles-paquetes">
            <GuiaProductos
              idguia={guia.id}
              embalajes={embalajes}
              paquetes={paquetes}
              productos={productos}
              onProductosChange={(productosSaved) => { this.setState({ 
                guia: {
                  ...guia,
                  productos: [...productosSaved] 
                }
              }) }}
            />
          </div>
        )}

        <div className="row">
          {!noDetalles && (
            <>
              <div className="col-sm-12">
                <div className="row row-more-info">
                  <div className="col-12 col-sm-4">
                    <TextField
                      disabled={disabled ? disabled : false}
                      value={g_volumen_largo}
                      onChange={(event) =>
                        this.onValueChange(event, "g_volumen_largo")
                      }
                      type="number"
                      label="Volumen-largo"
                      variant="outlined"
                      fullWidth
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">cm</InputAdornment>
                        ),
                      }}
                    />
                  </div>
                  <div className="col-12 col-sm-4">
                    <TextField
                      disabled={disabled ? disabled : false}
                      value={g_volumen_alto}
                      onChange={(event) =>
                        this.onValueChange(event, "g_volumen_alto")
                      }
                      type="number"
                      label="Volumen-alto"
                      variant="outlined"
                      fullWidth
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">cm</InputAdornment>
                        ),
                      }}
                    />
                  </div>
                  <div className="col-12 col-sm-4">
                    <TextField
                      disabled={disabled ? disabled : false}
                      value={g_volumen_ancho}
                      onChange={(event) =>
                        this.onValueChange(event, "g_volumen_ancho")
                      }
                      type="number"
                      label="Volumen-ancho"
                      variant="outlined"
                      fullWidth
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">cm</InputAdornment>
                        ),
                      }}
                    />
                  </div>
                  <div className="col-12 col-sm-4">
                    <TextField
                      disabled={disabled ? disabled : false}
                      value={g_peso_volumetrico}
                      onChange={(event) =>
                        this.onValueChange(event, "g_peso_volumetrico")
                      }
                      type="number"
                      label="Peso Volumetrico"
                      variant="outlined"
                      fullWidth
                    />
                  </div>
                  <div className="col-12 col-sm-4">
                    <TextField
                      readOnly
                      value={g_peso_real}
                      //onChange={(event) => this.onValueChange(event, 'g_peso_real')}
                      type="number"
                      label="Peso Real"
                      variant="outlined"
                      fullWidth
                    />
                  </div>
                  <div className="col-12 col-sm-4">
                    <TextField
                      readOnly
                      value={g_piezas}
                      //onChange={(event) => this.onValueChange(event, 'g_piezas')}
                      type="number"
                      label="Piezas"
                      variant="outlined"
                      fullWidth
                    />
                  </div>
                  <div className="col-6">
                    <TextField
                      disabled={disabled ? disabled : false}
                      value={g_observaciones || ''}
                      onChange={(event) =>
                        this.onValueChange(event, "g_observaciones")
                      }
                      label="Observaciones"
                      multiline
                      fullWidth
                      minRows="2"
                      variant="outlined"
                    />
                  </div>
                  <div className="col-6">
                    <TextField
                      disabled={disabled ? disabled : false}
                      value={g_dimensiones || ''}
                      onChange={(event) =>
                        this.onValueChange(event, "g_dimensiones")
                      }
                      label="Dimensiones"
                      multiline
                      fullWidth
                      minRows="2"
                      variant="outlined"
                    />
                  </div>
                </div>
              </div>

              <div className="col-sm-12">
                <div className="row">
                  <div className="col-6">
                    <div>Tipo de Servicio</div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          disabled={disabled ? disabled : false}
                          checked={g_autoservicio || false}
                          onChange={(event) =>
                            this.onValueChange(
                              { target: { value: event.target.checked } },
                              "g_autoservicio"
                            )
                          }
                          name="g_autoservicio"
                        />
                      }
                      label="Autoservicio"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          disabled={disabled ? disabled : false}
                          checked={g_almacenaje || false}
                          onChange={(event) =>
                            this.onValueChange(
                              { target: { value: event.target.checked } },
                              "g_almacenaje"
                            )
                          }
                          name="g_almacenaje"
                        />
                      }
                      label="Almacenaje"
                    />

                    <FormControlLabel
                      control={
                        <Checkbox
                          disabled={disabled ? disabled : false}
                          checked={g_completo || false}
                          onChange={(event) =>
                            this.onValueChange(
                              { target: { value: event.target.checked } },
                              "g_completo"
                            )
                          }
                          name="g_completo"
                        />
                      }
                      label="Completo"
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          <div className="col-sm-6 row-more-info">
            <CobroServicios
              disabled={disabled ? disabled : false}
              disableRecoleccion
              disableFlete
              disableCpac
              title={"Servicios Incluidos en la Guía"}
              inverse
              fillValue
              tipoServicios={{ g_autoservicio, g_almacenaje, g_completo }}
              handleOnCobroServicios={this.handleOnUserSelectService}
              tiposListas={tiposCobro}
              listaPreciosServicios={{ especificaciones: serviciosIncluidos }}
            />
          </div>

          <div className="col-sm-6">
            <div className="row row-more-info precios-container">
              {tiposCobro.map((tipoCobro) => (
                <div key={tipoCobro.id} className="col-12 col-sm-6">
                  <TextField
                    readOnly
                    // type="number"
                    value={guia[`tipo_${tipoCobro.id}`] || "0"}
                    label={tipoCobro.lpt_nombre}
                    variant="outlined"
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">$</InputAdornment>
                      ),
                    }}
                  />
                  <div className="msg-info">
                    <span>
                      {priceInfo[`tipo_${tipoCobro.id}`] &&
                        priceInfo[`tipo_${tipoCobro.id}`].lp &&
                        `Obtenido de: ${priceInfo[`tipo_${tipoCobro.id}`].lp}`}
                    </span>
                    <span>
                      {priceInfo[`tipo_${tipoCobro.id}`] &&
                        (tipoCobro.id === 1 || tipoCobro.id === 3) &&
                        priceInfo[`tipo_${tipoCobro.id}`].km &&
                        `Kilometros Calculados: ${
                          priceInfo[`tipo_${tipoCobro.id}`].km
                        }`}
                    </span>
                  </div>
                </div>
              ))}
              <div className="col-12 col-sm-12">
                <TextField
                  readOnly
                  value={guia["g_costo_subtotal"] || "0"}
                  type="number"
                  label="Subtotal"
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="col-12 col-sm-12">
                <TextField
                  readOnly
                  value={guia["g_costo_iva"] || "0"}
                  type="number"
                  label="I.V.A."
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="col-12 col-sm-12">
                <TextField
                  readOnly
                  value={guia["g_costo_retencion"] || "0"}
                  type="number"
                  label="Retencion."
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="col-12 col-sm-12">
                <TextField
                  readOnly
                  value={guia["g_costo_total"] || "0"}
                  type="number"
                  label="Total"
                  variant="outlined"
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {!noDetalles && (
          <div>
            {cliente.cliente_manifiestos && (
              <div>
                <Button
                  onClick={() =>
                    this.setState({ dialogManifiesto: { visible: true } })
                  }
                >
                  Seleccionar manifiesto
                </Button>
                <span>
                  Manifiestos seleccionados: {manifiestos.length || "Ninguno"}
                </span>

                <Dialog
                  onClose={() =>
                    this.setState({ dialogManifiesto: { visible: false } })
                  }
                  open={dialogManifiesto.visible}
                >
                  <DialogContent>
                    <ManifiestosCliente
                      idCliente={cliente.id}
                      selectOne={true}
                      onSelectOne={this.onSelectManifiesto}
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button
                      autoFocus
                      onClick={() =>
                        this.setState({ dialogManifiesto: { visible: false } })
                      }
                      color="primary"
                    >
                      Cerrar
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>
            )}
          </div>
        )}
        <div className="button-container">
          <Button
            disabled={
              (disabled ? (activateByManifiesto ? false : disabled) : false) ||
              !valid ||
              calculating
            }
            variant="contained"
            color="primary"
            onClick={this.onSubmit}
          >
            Guardar guía
          </Button>
        </div>
        
        <div>
          <Snackbar
            open={sbOpen}
            onClose={() => {
              this.setState({ sbOpen: false });
            }}
            TransitionComponent={Slide}
            ContentProps={{
              "aria-describedby": "message-id",
            }}
            message={<span id="message-id">{sbMsg}</span>}
          />
        </div>
      </div>
    );
  }
}
